import { normalize } from '#src/app/shared/utils/string';

// helper function to check if AI draft has been edited
// this information is passed in the activate_petition tracking event
export function compareNormalizedStrings(base: string | undefined | null, value: string): boolean | null {
	if (base === undefined || base === null) return null;

	return normalize(base) !== normalize(value);
}
